import * as React from "react"
const SvgExternal = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m16 10.257-8.9 8.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7l8.9-8.9H7a.97.97 0 0 1-.712-.287A.97.97 0 0 1 6 7.857q0-.424.288-.712A.97.97 0 0 1 7 6.857h10q.424 0 .712.288a.97.97 0 0 1 .288.712v10a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713z" />
  </svg>
)
export default SvgExternal
